<template>
    <div>
        <kgr-empty
            v-if="departments.length === 0"
            :value="$t('Es wurden keine Ergebnisse gefunden.')"
        />

        <div
            v-else
            class="kgr-grid kgr-grid--gutters kgr-grid--inlineBlock animated fadeIn"
        >
            <div
                v-for="department in filteredAndSortedDepartments"
                :key="department.id"
                class="kgr-grid__cell app-gridCard container_child"
            >
                <div class="kgr-card">
                    <kgr-image
                        class="kgr-card__image kgr-card__image--full"
                        :src="urlForListThumb(department)"
                        :alt="department.name"
                    />

                    <h3
                        v-if="department.hierarchyPath"
                        class="kgr-card__name small"
                    >
                        {{ department.hierarchyPath }}
                    </h3>

                    <h3 class="kgr-card__name child_name">
                        <a
                            v-if="department.isViewable || department.isEditable"
                            :href="urlForDepartmentEdit(department.id)"
                        >
                            {{ department.name }}
                        </a>
                        <template v-else>
                            {{ department.name }}
                        </template>
                    </h3>

                    <div class="kgr-card__contents">
                    </div>
                </div>
            </div>
        </div>
    </div>
</template>

<script>
import EmptyData from '../common/EmptyData';
import Image from '../common/Image';
import UrlMixin from './UrlMixin';

export default {
    name: 'KgrDepartmentsGrid',
    components: {
        'kgr-image': Image,
        'kgr-empty': EmptyData,
    },
    mixins: [UrlMixin],
    props: {
        departments: {
            type: Array,
            required: true,
        },
        filter: {
            type: String,
            required: false,
        },
        includeChildren: {
            type: Boolean,
            required: true,
        },
    },
    computed: {
        flattenedDepartments() {
            return this.extractChildDepartments(this.departments, []);
        },
        filteredAndSortedDepartments() {
            let departments = this.flattenedDepartments.slice(0);

            if (!this.includeChildren) {
                departments = departments.filter(department => department.isRoot);
            }

            if (null !== this.filter && '' !== this.filter) {
                const filter = this.filter.toLowerCase().trim();
                departments = departments.filter(department => {
                    return department.name.toLowerCase().indexOf(filter) !== -1
                            || (department.shortName && department.shortName.toLowerCase().indexOf(filter) !== -1)
                            || (department.hierarchyPath && department.hierarchyPath.toLowerCase().indexOf(filter) !== -1);
                });
            }

            return departments;
        },
    },
    methods: {
        extractChildDepartments(childDepartments, departments) {
            childDepartments.forEach(department => {
                departments.push(department);
                departments = this.extractChildDepartments(department.childDepartments, departments);
            });

            return departments;
        },
    },
}
</script>

<style scoped lang="scss" rel="stylesheet/scss">
    .small {
        font-size: 85%;
        opacity: 0.5;
    }
</style>
